import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { AbstractItemList } from "./ItemListComponents";
import { FastClick } from "../../../core/react/FastClick";

var defaults = require("lodash/defaults");

export var ItemHistogramComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ItemHistogramComponent, _React$PureComponent);

  function ItemHistogramComponent() {
    _classCallCheck(this, ItemHistogramComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ItemHistogramComponent).apply(this, arguments));
  }

  _createClass(ItemHistogramComponent, [{
    key: "getCountRatio",
    value: function getCountRatio() {
      var _this$props = this.props,
          rawCount = _this$props.rawCount,
          listDocCount = _this$props.listDocCount;

      if (rawCount == undefined || listDocCount == undefined || listDocCount == 0) {
        return 0;
      } else {
        return rawCount / listDocCount;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          bemBlocks = _this$props2.bemBlocks,
          onClick = _this$props2.onClick,
          active = _this$props2.active,
          disabled = _this$props2.disabled,
          style = _this$props2.style,
          itemKey = _this$props2.itemKey,
          label = _this$props2.label,
          count = _this$props2.count,
          showCount = _this$props2.showCount,
          showCheckbox = _this$props2.showCheckbox;
      var block = bemBlocks.option;
      var className = block().state({
        active: active,
        disabled: disabled,
        histogram: true
      }).mix(bemBlocks.container("item"));
      var barWidth = this.getCountRatio() * 100 + '%';
      return React.createElement(FastClick, {
        handler: onClick
      }, React.createElement("div", {
        className: className,
        style: style,
        "data-qa": "option",
        "data-key": itemKey
      }, React.createElement("div", {
        className: block("bar-container")
      }, React.createElement("div", {
        className: block("bar"),
        style: {
          width: barWidth
        }
      })), showCheckbox ? React.createElement("input", {
        type: "checkbox",
        "data-qa": "checkbox",
        checked: active,
        readOnly: true,
        className: block("checkbox").state({
          active: active
        })
      }) : undefined, React.createElement("div", {
        "data-qa": "label",
        className: block("text")
      }, label), showCount && count != undefined ? React.createElement("div", {
        "data-qa": "count",
        className: block("count")
      }, count) : undefined));
    }
  }]);

  return ItemHistogramComponent;
}(React.PureComponent);
export var ItemHistogramList =
/*#__PURE__*/
function (_AbstractItemList) {
  _inherits(ItemHistogramList, _AbstractItemList);

  function ItemHistogramList() {
    _classCallCheck(this, ItemHistogramList);

    return _possibleConstructorReturn(this, _getPrototypeOf(ItemHistogramList).apply(this, arguments));
  }

  return ItemHistogramList;
}(AbstractItemList);
ItemHistogramList.defaultProps = defaults({
  //mod: "sk-item-histogram",
  itemComponent: ItemHistogramComponent,
  showCount: true
}, AbstractItemList.defaultProps);